import React from 'react';
import { APIProvider, useApiIsLoaded } from '@vis.gl/react-google-maps';
import { GOOGLE_CONFIG } from '../../utils/constants';
import PropTypes from 'prop-types';

const GoogleComponents = ({children}) => {
    const isLoaded = useApiIsLoaded();

    if (!isLoaded) {
      return <div>Loading Google Component...</div>;
    }

    return (
        <>{children}</>
    );
};

GoogleComponents.propTypes = {
    children: PropTypes.node
};

const GoogleWrapper = ({children}) => {
    return (
        <APIProvider apiKey={GOOGLE_CONFIG.googleMapsApiKey}>
            <GoogleComponents>
                {children}
            </GoogleComponents>
        </APIProvider>
    );
};

GoogleWrapper.propTypes = {
    children: PropTypes.node
};

export default GoogleWrapper;